<template>
	<el-dialog :visible.sync="dialogShow" :close-on-click-modal="false" :append-to-body="true" :modal-append-to-body="true" custom-class="radius5" width="420px" class="pm-remove">
		<span slot="title" class="text-danger flex align-items-center">
			<i class="el-icon-warning font-lg top1"></i>
			<span class="font-18 text-bold ml-sm">彻底删除项目</span>
		</span>
		<div> 一旦彻底删除项目<span class="text-danger">【{{ title }}】</span>，项目及包含的所有信息将会被永久删除，无法找回，该操作不可恢复。请确认是否彻底删除？ </div>
		<div slot="footer">
			<el-button size="small" @click="dialogShow = false">取消</el-button>
			<el-button size="small" type="danger" @click="submit">确定</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		show: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ''
		}
	},

	data () {
		return {
			moreShow: true
		}
	},

	computed: {
		dialogShow: {
			get () {
				return this.show
			},
			set (val) {
				this.$emit('update:show', val)
			}
		}
	},

	methods: {
		submit () {
			this.$emit('change')
			this.dialogShow = false
		}
	}
}
</script>

<style lang="scss">
.pm-remove {
	.el-dialog__body {
		padding: 10px 20px;
	}
}
</style>